import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import vPosterImg from "../assets/images/v-poster.png";
import { candidateExplainerData as data } from "../data/candidate-explainer.data";
import { useRedirectUrl } from "../hooks/useRedirectUrl";
import styles from "./candidate-explainer.module.scss";
import msgImg from "../assets/images/si/msg.png";
import videoImg from "../assets/images/si/video.png";
import toolsImg from "../assets/images/si/tools.png";
import phImg from "../assets/images/si/ph.png";
import siVideo from "../assets/videos/PHAI006_SecondInterview_005.mp4";
import "./candidate-explainer.scss";

export function SiSupport() {
  const redirect = useRedirectUrl("/second-interview-support");

  return (
    <div className={`${styles["candidateExplainer"]} candidate-container`}>
      <Helmet>
        <title>Sapia | Candidate Explainer</title>
        <meta http-equiv="refresh" content="0; url=https://sapia.ai/second-interview-support/" />
      </Helmet>

      {/* <div className={styles["explainerBanner"]}>
        <ul className={styles["landingBreadcrumbs"]}>
          <li className={styles["candidateBtn"]}>
            <a href={redirect}>{"<"} BACK</a>
          </li>
          <li>
            <Link to="/si-privacy-policy">Privacy Policy</Link>
          </li>

          <span>&</span>

          <li>
            <Link to="/si-terms-of-service">Terms Of Service</Link>
          </li>
        </ul>

        <div className={styles["explainerBannerText"]}>
          <h1>
            Welcome to your video interview: &nbsp;
            <span>Support page for candidates</span>
          </h1>
          <p>
            The SecondInterview is another opportunity to express yourself, in
            your own words, but this time using video!
          </p>
          <p>
            Often when applying for roles, especially with big companies,
            candidates aren’t able to fully express why they would be great for
            the job. With thousands of CV’s to review, great candidates like you
            can get missed. To give every candidate a fair go, and the chance to
            be interviewed and assessed equally, we designed a unique interview
            experience that allows you to record and save your answers at your
            convenience, using any device.
          </p>
        </div>
      </div>

      <div className={styles.explainerVideo}>
        <video src={siVideo} controls ></video>
        <div
          className={`${styles["candidateBtn"]} ${styles["candidateBtn_Red"]}`}
        >
          <a href={redirect}>{data.header_section.back_link_label}</a>
        </div>
      </div>

      <div className={styles.siContent}>
        <div className={styles.siNav}>
          <Link to="/second-interview-support-about">
            <div className={styles.siNavItem}>
              <img src={phImg} alt="" />
              <span>About Sapia video interviews</span>
            </div>
          </Link>

          <Link to="/second-interview-support-how-to">
            <div className={styles.siNavItem}>
              <img src={videoImg} alt="" />
              How to complete your interview
            </div>
          </Link>

          <Link to="/second-interview-support-issues">
            <div className={styles.siNavItem}>
              <img src={toolsImg} alt="" />
              Technical issues and troubleshooting
            </div>
          </Link>

          <Link to="/second-interview-support-more">
            <div className={styles.siNavItem}>
              <img src={msgImg} alt="" />
              More frequently asked questions
            </div>
          </Link>
        </div>
      </div>

      <div className="interview-support-section explainer-padding">
        <div className="container">
          <div className="text-center">
            <h3 className="blue-title">{data.contact_section.section_title}</h3>
            <button
              type="button"
              className="btn-help"
              style={{ cursor: "pointer" }}
            >
              {data.contact_section.button_label}
            </button>
            <p>
              <a
                href={data.contact_section.privacy_button_link}
                className="black-link"
              >
                {data.contact_section.privacy_button_label}
              </a>
            </p>
            <p>
              <a href="/terms-of-service" className="black-link">
                Read our Terms of Service here {">"}
              </a>
            </p>
          </div>
        </div>
      </div> */}
    </div>
  );
}
